export const books = [
  {
    id: 1,
    number: "I",
    title: {
      de: "Das mächtige Königreich",
      en: "The Mighty Kingdom"
    },
    subtitle: {
      de: "Der Beginn von Zīxuě's Reise",
      en: "The Beginning of Zīxuě's Journey"
    },
    status: {
      de: "In Vorbereitung",
      en: "In Preparation"
    },
    color: "#E8DDC8",
    teaser: {
      de: "Der Kaiser von Ruìhuá erhält endlich eine frohe Botschaft, und einer Heirat scheint nichts mehr im Weg zu stehen. Doch im Palast stauen sich Spannungen an. Die Situation verschärft sich weiter, als die wichtigsten Königreiche des Landes ebenfalls in der Hauptstadt eintreffen, um zu heiraten. Werden die Königreiche die Pläne des Kaiserreichs erfüllen können? Und wer ist eigentlich die geheimnisvolle Kaiserin, die das Reich seit ihrer Ankunft im Palast wahrhaftig aus seinem Schatten holt?",
      en: "The Emperor of Ruìhuá finally receives glad tidings, and nothing seems to stand in the way of a marriage. Yet, tensions are brewing within the palace. The situation intensifies further when the land's most vital kingdoms also arrive in the capital to wed. Will the kingdoms be able to fulfill the Empire's grand designs? And who truly is the mysterious Empress, who has genuinely lifted the realm from its shadows since her arrival at the palace?"
    },
    chapters: "XX",
    coverUrl: "/covers/Band1_Cover.png"
  },
  {
    id: 2,
    number: "II",
    title: {
      de: "Das geheimnisvolle Königreich",
      en: "The Mysterious Kingdom"
    },
    subtitle: {
      de: "Der Kaiser und seine Schatten",
      en: "The Emperor and His Shadows"
    },
    status: {
      de: "In Planung",
      en: "In Planning"
    },
    color: "#C9A227",
    teaser: {
      de: "-",
      en: "-"
    },
    chapters: "XX",
  },
  {
    id: 3,
    number: "III",
    title: {
      de: "Das besondere Königreich",
      en: "The Special Kingdom"
    },
    subtitle: {
      de: "Krieg in den Bergen",
      en: "War in the Mountains"
    },
    status: {
      de: "In Planung",
      en: "In Planning"
    },
    color: "#B01218",
    teaser: {
      de: "-",
      en: "-"
    },
    chapters: "XX",
  },
  {
    id: 4,
    number: "IV",
    title: {
      de: "Das ferne Königreich",
      en: "The Distant Kingdom"
    },
    subtitle: {
      de: "Die Wurzeln der Götter",
      en: "The Roots of the Gods"
    },
    status: {
      de: "In Planung",
      en: "In Planning"
    },
    color: "#0F8B6D",
    teaser: {
      de: "-",
      en: "-"
    },
    chapters: "XX",
  },
  {
    id: 5,
    number: "V",
    title: {
      de: "Das verstorbene Königreich",
      en: "The Deceased Kingdom"
    },
    subtitle: {
      de: "Die verschollenen Thronfolger",
      en: "The Lost Heirs to the Throne"
    },
    status: {
      de: "In Planung",
      en: "In Planning"
    },
    color: "#2E78A8",
    teaser: {
      de: "-",
      en: "-"
    },
    chapters: "XX",
  },
  {
    id: 6,
    number: "VI",
    title: {
      de: "Das fremde Königreich",
      en: "The Foreign Kingdom"
    },
    subtitle: {
      de: "Das Ende und der Anfang",
      en: "The End and the Beginning"
    },
    status: {
      de: "In Planung",
      en: "In Planning"
    },
    color: "#9b519d",
    teaser: {
      de: "-",
      en: "-"
    },
    chapters: "XX",
  },
];